const capitalizeFirst = (texto) => {
  if (!texto) return texto;
  return texto.charAt(0).toUpperCase() + texto.slice(1);
};

const pluralizarLower = (lower) => {
  if (lower === "profissional") return "profissionais";
  if (lower.endsWith("al")) return `${lower.slice(0, -2)}ais`;
  if (lower.endsWith("el")) return `${lower.slice(0, -2)}éis`;
  if (lower.endsWith("ão")) return `${lower.slice(0, -2)}ões`;
  if (lower.endsWith("r") || lower.endsWith("z") || lower.endsWith("s")) {
    return `${lower}es`;
  }
  if (/[aeiouáéíóúâêîôûãõ]$/i.test(lower)) return `${lower}s`;
  return `${lower}s`;
};

/**
 * Heurística PT-BR:
 * - termina em "a" → feminino (cabeleireira, manicure* via lista)
 * - -ista / -ente → masculino gramatical neutro comum (usa "o")
 * - restante → masculino (barbeiro, profissional)
 */
const FEMININOS_EXPLICITOS = new Set([
  "manicure",
  "pedicure",
  "massagista", // comum usar "a massagista"
]);

const ROTULO_DISPLAY = {
  veterinario: { singular: "Veterinário", plural: "Veterinários" },
};

const isFeminino = (lower) => {
  if (!lower) return false;
  if (FEMININOS_EXPLICITOS.has(lower)) return true;
  if (lower.endsWith("ista") || lower.endsWith("ente")) return false;
  return /a$/i.test(lower);
};

export const getProfissionalLabels = (config) => {
  const raw = config?.rotulo_profissional;
  const trimmed =
    raw === null || raw === undefined ? "" : String(raw).trim();

  const base = trimmed ? trimmed.toLowerCase() : "profissional";
  const feminino = trimmed ? isFeminino(base) : false;
  const display = ROTULO_DISPLAY[base];
  const singular = display?.singular || capitalizeFirst(base);
  const plural = display?.plural || capitalizeFirst(pluralizarLower(base));

  return {
    singular,
    plural,
    singularLower: singular.toLowerCase(),
    pluralLower: plural.toLowerCase(),
    feminino,
    artigo: feminino ? "a" : "o",
    de: feminino ? "da" : "do",
    um: feminino ? "uma" : "um",
    novo: feminino ? "Nova" : "Novo",
    este: feminino ? "Esta" : "Este",
    nenhum: feminino ? "Nenhuma" : "Nenhum",
    outro: feminino ? "Outra" : "Outro",
    unico: feminino ? "única" : "único",
    criado: feminino ? "criada" : "criado",
    atualizado: feminino ? "atualizada" : "atualizado",
    excluido: feminino ? "excluída" : "excluído",
    encontrado: feminino ? "encontrada" : "encontrado",
    vinculado: feminino ? "vinculada" : "vinculado",
  };
};
